/**
 * @file The upload base service
 * @author Heino Lenting
 */
import { saveAs } from 'file-saver';
/**
 * Class for the upload service base
 */
var UploadService = /** @class */ (function () {
    /**
     * Constructs an UploadService.
     * @param alertsService Service for giving user feedback
     */
    function UploadService(alertsService) {
        this.alertsService = alertsService;
        /** The allowed mime types */
        this.allowedMimeTypes = [];
        /** The allowed file size in bytes */
        this.allowedFileSizeInBytes = 1000000; // = Megabyte
        /** The available files (only for demo!) */
        this.uploads = [];
    }
    /**
     * Validates a file, returns a File promise
     * @param file The file to validate
     */
    UploadService.prototype.validate = function (file) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // If we have a file?
            if (!file) {
                return reject(new Error('No file present'));
            }
            // Check mime type
            if (_this.allowedMimeTypes.indexOf(file.type) === -1) {
                return reject(new Error('Invalid file type'));
            }
            // Check file size
            if (file.size > _this.allowedFileSizeInBytes) {
                return reject(new Error('File too large'));
            }
            resolve(file);
        });
    };
    /**
     * Reads a file, returns a FileData promise
     * @param file The file to read
     */
    UploadService.prototype.read = function (file) {
        return new Promise(function (resolve, reject) {
            // Create file reader and set onloaded
            var reader = new FileReader();
            reader.onloadend = function (e) {
                resolve({ fileName: file.name, data: reader.result });
            };
            // Start reading
            reader.readAsArrayBuffer(file);
        });
    };
    /**
     * Temporary delay function for demo purposes
     */
    UploadService.prototype.delay = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    /**
     * The default upload handler, returns a FileData promise
     * @param item The entity the upload belongs to
     * @param fileData The file data
     */
    UploadService.prototype.upload = function (item, fileData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Demo add
            _this.delay(3000).then(function () {
                _this.uploads.push({
                    id: 0,
                    filename: fileData.fileName,
                    url: '/Planning automation.pdf',
                    type: 'application/pdf',
                    size: 167300,
                    user: 'Tom Verschoore de la Houssaije',
                    created: new Date(Date.now() - Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7 * 3))
                });
            }).then(function () {
                resolve(fileData);
            });
        });
    };
    /**
     * The default delete handler
     * @param item The entity the upload belongs to
     * @param fileId The id of the file
     */
    UploadService.prototype.deleteUpload = function (item, fileId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // Later: call to backend
            // Demo delete
            _this.uploads = _this.uploads.filter(function (upload) { return upload.id !== fileId; });
            resolve(true);
        });
    };
    /**
     * The default get file handler for only one file
     * @param item The entity the upload belongs to
     */
    UploadService.prototype.getFile = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // todo call to backend
            // demo download
            var blob = new Blob(['Hello, world!'], { type: 'text/plain;charset=utf-8' });
            saveAs(blob, 'hello world.txt');
            if (_this.uploads && _this.uploads.length) {
                return resolve(_this.uploads[0]);
            }
            reject(new Error('could not download file'));
        });
    };
    /**
     * The default get file handler for all files
     * @param item The entity the upload belongs to
     */
    UploadService.prototype.getFiles = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // todo call to backend
            return resolve(_this.uploads);
        });
    };
    return UploadService;
}());
export { UploadService };
